<template>  
<div> <!-- root element start -->
          <div class="row">
            <div class="col-12">
                <div class="card border-0">
                  <div class="card-header font-weight-bold bg-transparent border-0">
                    <i class="fa fa-pencil-square-o text-success" aria-hidden="true" @click="changeBottomView('item-detail-edit', '','',[])" ></i> 
                    Item Details</div>

                  <div v-if="detailsComp == 0" class="card-body">
                    <div class="col-12 mt-4">
                      <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
                    </div>
                  </div>
                    
                  <div v-if="detailsComp == 1" class="card-body border-bottom" style="height:400px; overflow:auto">
                    <div class="row mb-3">
                      <div class="col-12 d-flex align-items-center">
                        <span class="small text-muted mr-2">Name:</span> {{ detailsList.name }}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12 col-lg-4 d-flex align-items-center">
                        <span class="small text-muted mr-2">System ID:</span> {{ detailsList.id }}
                      </div>
                      <div class="col-12 col-lg-4 d-flex align-items-center">
                        <span class="small text-muted mr-2">Part Number:</span> {{ detailsList.part_number }}
                      </div>
                      <div class="col-12 col-lg-4 d-flex align-items-center">
                        <span class="small text-muted mr-2">Status:</span> {{ detailsList.statusName }}
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-12 col-lg-6 d-flex align-items-center">
                        <span class="small text-muted mr-2">Price:</span> {{ detailsList.price | currency }}
                      </div>
                      <div class="col-12 col-lg-6 d-flex align-items-center">
                        <span class="small text-muted mr-2">Cost:</span> {{ detailsList.cost | currency }}
                      </div>
                    </div>

                    <div class="row mb-5">
                      <div class="col-12 d-flex align-items-center">
                        <span class="small text-muted mr-2">Description:</span> {{ detailsList.description }}
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-12 col-lg-3 d-flex align-items-center">
                        <span class="small text-muted mr-2">Quantity Allowed:</span> {{ detailsList.qty_allow | oneToNo }}
                      </div>
                      <div v-if="detailsList.qty_allow == 0" class="col-12 col-lg-3 d-flex align-items-center">
                        <span class="small text-muted mr-2">Minimum:</span> {{ detailsList.min_allow }}
                      </div>
                      <div v-if="detailsList.qty_allow == 0" class="col-12 col-lg-3 d-flex align-items-center">
                        <span class="small text-muted mr-2">Maximum:</span> {{ detailsList.max_allow }}
                      </div>
                      <div v-if="detailsList.qty_allow == 0" class="col-12 col-lg-3 d-flex align-items-center">
                        <span class="small text-muted mr-2">Interval:</span> {{ detailsList.interval_add }}
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-12 col-lg-4">
                        <span class="small text-muted mr-2">Requires Items:</span> {{ detailsList.require_allow | oneToNo }}
                      </div>
                      <div v-if="detailsList.require_allow == 0" class="col-12 col-lg-8">
                        <span class="small text-muted mr-2">Items Required:</span> {{ detailsList.max_allow }}
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-12 col-lg-4">
                        <span class="small text-muted mr-2">Excludes Items:</span> {{ detailsList.exclude_allow | oneToNo }}
                      </div>
                      <div v-if="detailsList.exclude_allow == 0" class="col-12 col-lg-8">
                        <span class="small text-muted mr-2">Items Excluded:</span> {{ detailsList.max_allow }}
                      </div>
                    </div>

                  </div>
                </div>
            </div>
            
          </div>

          <div class="row">
            <transition name="slide-fade" mode="out-in">
                <component 
                  :is="bottomView" 
                  :prop1="bvProp1" 
                  :prop2="bvProp2" 
                  :prop3="bvProp3" 
                  @onSComplete="successComplete" 
                  @onUComplete="unsuccessComplete"
                  @secondaryAction="secondaryAction"
                >
                </component>
              </transition>
          </div>

</div> <!-- root element end -->
</template>


<script>

import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-item-single-main-store.js'

import editDetail from './itemDetailComponents/item-detail-edit.vue'

export default {
  props: ['item'],
  store,
  data: function () {
    return { 
      bottomView: '',
      bvProp1: '',
      bvProp2: '',
      bvProp3: [],
      loading: '1',
      orderChangeButton: '0',
    }
  },
  computed: {
    detailsList() { return this.$store.state.detailsList },
    detailsComp() { return this.$store.state.detailsComp },
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    changeBottomView(name, prop1, prop2, prop3) { this.bottomView = name; this.bvProp1 = prop1; this.bvProp2 = prop2; this.bvProp3 = prop3; },
    getAllItemProducts() { this.$store.dispatch("getAllItemProducts", { prod: this.detailsList.id }) },
    getItemDetails() { this.$store.dispatch("getItemDetails", { prod: this.detailsList.id }) },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'item-detail-edit':
          _this.getItemDetails();
          _this.changeBottomView('', '', '', []);
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'item-detail-edit':
          _this.changeBottomView('', '', '', []);
        break;

        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 1:
        var setup = [value[2]];
          _this.changeBottomView(value[1], '', '', setup);
        break;
        
        default:
      }
    },

    deleteInclude(x) {
      var _this = this;
      _this.changeBottomView('', '', '', []);
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.get('/admin/utility/product/item/deleterel/' + x)
          .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.getAllItemProducts();
          })
        }
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
    
  },    
  components:{
    
    ScalingSquaresSpinner,
    'item-detail-edit' : editDetail
    
  },
  filters: {
    oneToNo(val) {
      if(val == 0) {
        return "Yes";
      } else {
        return "No";
      }
    },

  }
}
</script>
